import axios from '../utils/axios';

export default function getMailerStats(adminId, id) {
    return axios.get(`/admin/${adminId}/tag-mailers/${id}/stats`)
}
